module.exports = __webpack_public_path__ + "static/memories-3621196c124aa362fb352e6ccb04d091.jpg";